import { Expose } from 'class-transformer'

export class Profile {
  @Expose({ name: 'xid' })
  guid?: string

  email: string = ''

  @Expose({ name: 'first_name' })
  firstName: string = ''

  @Expose({ name: 'last_name' })
  lastName: string = ''

  @Expose({ name: 'profile_image' })
  profileImage?: string

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }
}
